import * as React from 'react';
import classNames from 'clsx';
import styles from './style/shapeDividers.scss';
const generateLayers = (hasDivider, layersSize) => {
    return hasDivider
        ? [...Array(1 + (layersSize || 0)).keys()]
            .reverse()
            .map(i => (React.createElement("div", { style: { '--divider-layer-i': i }, className: styles.dividerLayer, "data-testid": `divider-layer-${i}`, "data-divider-layer": i })))
        : null;
};
export const generateDivider = (side, hasDivider, size) => {
    const dividerLayers = generateLayers(!!hasDivider, size);
    return hasDivider ? (React.createElement("div", { className: classNames(styles.shapeDivider, {
            [styles.topShapeDivider]: side === 'top',
            [styles.bottomShapeDivider]: side === 'bottom',
        }), "data-testid": `${side}-divider` }, dividerLayers)) : null;
};
const ShapeDividers = dividers => {
    var _a, _b;
    const topDivider = React.useMemo(() => {
        var _a;
        return generateDivider('top', dividers === null || dividers === void 0 ? void 0 : dividers.hasTopDivider, (_a = dividers === null || dividers === void 0 ? void 0 : dividers.topLayers) === null || _a === void 0 ? void 0 : _a.size);
    }, [dividers === null || dividers === void 0 ? void 0 : dividers.hasTopDivider, (_a = dividers === null || dividers === void 0 ? void 0 : dividers.topLayers) === null || _a === void 0 ? void 0 : _a.size]);
    const bottomDivider = React.useMemo(() => {
        var _a;
        return generateDivider('bottom', dividers === null || dividers === void 0 ? void 0 : dividers.hasBottomDivider, (_a = dividers === null || dividers === void 0 ? void 0 : dividers.bottomLayers) === null || _a === void 0 ? void 0 : _a.size);
    }, [dividers === null || dividers === void 0 ? void 0 : dividers.hasBottomDivider, (_b = dividers === null || dividers === void 0 ? void 0 : dividers.bottomLayers) === null || _b === void 0 ? void 0 : _b.size]);
    return (React.createElement(React.Fragment, null,
        topDivider,
        bottomDivider));
};
export default ShapeDividers;
//# sourceMappingURL=shapeDividers.js.map